import { Oval } from "react-loader-spinner";

interface KimaruLoaderProps {
    size?: any;
    color?: any;
    secondaryColor?: any;
    className?: any;
    wrapperClassName?: any;
}

function KimaruLoader({
    size = 80,
    color = "#4F46E5",
    secondaryColor = "#6D28D9",
    className = "",
    wrapperClassName = "flex justify-center items-center h-96"
}: KimaruLoaderProps) {
    return (
        <div className={wrapperClassName}>
            <Oval
                height={size}
                width={size}
                color={color}
                wrapperStyle={{}}
                wrapperClass={className}
                visible={true}
                ariaLabel="oval-loading"
                secondaryColor={secondaryColor}
                strokeWidth={2}
                strokeWidthSecondary={2}
            />
        </div>
    );
}

export default KimaruLoader;
